// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Veri Yönetimi',
  subtitle: 'Verileri dışa aktarın ve yönetin',
  exportCustomers: 'Müşterileri Dışa Aktar',
  exportDomains: 'Domainleri Dışa Aktar',
  exportPayments: 'Ödemeleri Dışa Aktar',
  exportSuccess: 'Veriler başarıyla dışa aktarıldı',
  exportError: 'Dışa aktarma işlemi başarısız',
  importData: 'Veri İçe Aktar',
  importSuccess: 'Veriler başarıyla içe aktarıldı',
  importError: 'İçe aktarma işlemi başarısız',
  dataOperations: 'Veri İşlemleri',
  dataExport: 'Veri Dışa Aktarma',
  dataImport: 'Veri İçe Aktarma',
  exportAll: 'Tüm Verileri Dışa Aktar',
  exportAllDesc: 'Tüm tabloları tek bir JSON dosyasına dışa aktar',
  exportAllButton: 'Tümünü Dışa Aktar',
  exportSelected: 'Seçiliyi Dışa Aktar',
  exportSelectedDesc: 'Sadece seçili tabloları dışa aktar',
  exportSelectedButton: 'Seçiliyi Dışa Aktar',
  selectAll: 'Tümünü Seç',
  deselectAll: 'Seçimi Kaldır',
  selectAtLeastOne: 'Lütfen en az bir tablo seçin',
  exportLoading: 'Veriler dışa aktarılıyor...',
  exportSelectedLoading: 'Seçili tablolar dışa aktarılıyor...',
  exportSuccessCount: 'kayıt dışa aktarıldı',
  unknownError: 'Bilinmeyen hata',
  warning: 'Uyarı',
  warningDesc: 'İçe aktarma işlemleri mevcut verilerin üzerine yazabilir. İçe aktarmadan önce yedek alın.',
  selectJsonFile: 'JSON Dosyası Seçin',
  selectedFile: 'Seçili dosya',
  fileSize: 'KB',
  importOptions: 'İçe Aktarma Seçenekleri',
  clearExisting: 'İçe aktarmadan önce mevcut verileri temizle',
  clearExistingDesc: 'Yeni verileri içe aktarmadan önce mevcut kayıtları sil',
  skipDuplicates: 'Tekrarlayan kayıtları atla',
  skipDuplicatesDesc: 'Zaten var olan kayıtları içe aktarma',
  updateExisting: 'Mevcut kayıtları güncelle',
  updateExistingDesc: 'Eşleşen verilerle mevcut kayıtları güncelle',
  validateFile: 'Dosyayı Doğrula',
  importButton: 'Veriyi İçe Aktar',
  importing: 'İçe aktarılıyor...',
  fileValid: 'Dosya geçerli',
  fileHasErrors: 'Dosyada hatalar var',
  valid: 'geçerli',
  preparing: 'Hazırlanıyor...',
  table: 'tablo',
  recordsProcessed: 'kayıt işlendi',
  percent: '%',
  tables: {
    companies: 'Şirketler',
    companiesDesc: 'Şirket bilgileri',
    registrars: 'Kayıt Firmaları',
    registrarsDesc: 'Domain kayıt firmaları',
    servers: 'Sunucular',
    serversDesc: 'Sunucu bilgileri',
    accounts: 'Hesaplar (Cüzdan)',
    accountsDesc: 'Para hesapları ve bakiyeler',
    languages: 'Diller',
    languagesDesc: 'Sistem dilleri',
    users: 'Kullanıcılar',
    usersDesc: 'Sistem kullanıcıları',
    domainPrices: 'Domain Fiyatları',
    domainPricesDesc: 'Domain fiyat tanımlamaları',
    hostingPrices: 'Hosting Fiyatları',
    hostingPricesDesc: 'Hosting fiyat tanımlamaları',
    settings: 'Ayarlar',
    settingsDesc: 'Sistem ayarları',
    customers: 'Müşteriler',
    customersDesc: 'Müşteri bilgileri',
    domains: 'Domainler',
    domainsDesc: 'Domain bilgileri',
    companyPayments: 'Şirket Ödemeleri',
    companyPaymentsDesc: 'Ödeme kayıtları',
    payments: 'Ödemeler',
    paymentsDesc: 'Genel ödeme kayıtları',
    accountTransactions: 'Hesap İşlemleri',
    accountTransactionsDesc: 'Cüzdan işlemleri ve transferler',
    translations: 'Çeviriler',
    translationsDesc: 'Dil çevirileri',
    mobileAccessKeys: 'Mobil Erişim Anahtarları',
    mobileAccessKeysDesc: 'Mobil uygulama erişim anahtarları'
  },
  importErrorMessage: 'içe aktarma hatası',
  importAdded: 'eklendi',
  importUpdated: 'güncellendi',
  importSkipped: 'atlandı',
  importCompleted: 'İçe aktarma başarıyla tamamlandı',
  importLoading: 'Veriler içe aktarılıyor...',
  selectFileFirst: 'Lütfen önce bir dosya seçin',
  validatingFile: 'Dosya doğrulanıyor...',
  validationSuccess: 'Dosya başarıyla doğrulandı',
  validationError: 'Doğrulama başarısız',
  selectValidJson: 'Lütfen geçerli bir JSON dosyası seçin',
  exporting: 'Dışa aktarılıyor...'
};
